import classnames from 'classnames/bind'

import Image, { ImageProps } from '~/components/UI/Image'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export type BannerImageProps = {
  className?: string
  image?: ImageProps
  mobileImage?: ImageProps
}

function BannerImage({ className, image, mobileImage }: BannerImageProps) {
  const imgProps = {
    asPlaceholder: true,
    layout: 'fill' as 'fill' | '',
    objectFit: 'cover',
  } as Partial<ImageProps>

  return (
    <div className={cx(css.BannerImage, className)}>
      {image && (
        <Image
          className={cx(css.image, css.hideOnSmallScreen)}
          {...imgProps}
          {...image}
          priority={true}
          sizesFromBreakpoints={[
            { breakpoint: 'lg', ratio: 24 / 24 },
            { ratio: 16 / 16 },
          ]}
        />
      )}
      {mobileImage && (
        <Image
          className={cx(css.image, css.hideOnLargeScreen)}
          ratio={css.ratio}
          {...imgProps}
          {...mobileImage}
          priority={true}
          sizesFromBreakpoints={[
            { breakpoint: 'lg', ratio: 24 / 24 },
            { ratio: 16 / 16 },
          ]}
        />
      )}
    </div>
  )
}

BannerImage.defaultProps = {}

export default BannerImage
